import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../utils/database";
interface TabPanelProps {
  children?: React.ReactNode;
}

function More(props: TabPanelProps) {
  const { children, ...other } = props;
  const [email, setEmail] = useState("");
  const [jacobian3dik, setJacobian3dik] = useState(false);
  const [ccd, setCcd] = useState(false);
  const [lmdls, setLmdls] = useState(false);
  const [qncg, setQncg] = useState(false);
  const [lagrange, setLagrange] = useState(false);
  const [newtoneuler, setNewtoneuler] = useState(false);
  const [inversedynamics, setInversedynamics] = useState(false);
  const [astar, setAstar] = useState(false);
  const [dijkstra, setDijkstra] = useState(false);
  const [rrt, setRrt] = useState(false);
  const [prm, setPrm] = useState(false);
  const [jstragectories, setJstragectories] = useState(false);
  const [ostrajectories, setOstrajectories] = useState(false);
  const [pid, setPid] = useState(false);
  const [lqr, setLqr] = useState(false);
  const [foc, setFoc] = useState(false);
  const [kmfilter, setKmfilter] = useState(false);
  const [mpc, setMpc] = useState(false);
  const [bldc, setBldc] = useState(false);
  const [servo, setServo] = useState(false);
  const [stepper, setStepper] = useState(false);
  const [linearActuator, setLinearActuator] = useState(false);

  return (
    <>
      <Typography
        sx={{ width: 600, margin: 5, marginLeft: "auto", marginRight: "auto" }}
      >
        I am developing the visualization of other robotics topics currently. If
        you want to know when I finish these feature, join our{" "}
        <a href="https://discord.gg/TfwZ3hH2D2">Discord channel</a> ! I will
        release the latest version of website in the discord channel!
        <br />
        <br />
        Or you can select the topics you are interested and leave your email. I
        will notify you when your selected features are finished.
      </Typography>
      <Box>
        <TextField
          id="outlined-basic"
          label="email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          variant="contained"
          sx={{ margin: 1, width: 100 }}
          onClick={async () => {
            try {
              console.log(db);
              const docRef = await addDoc(collection(db, "emails"), {
                email,
                jacobian3dik,
                ccd,
                lmdls,
                qncg,
                lagrange,
                newtoneuler,
                inversedynamics,
                astar,
                dijkstra,
                rrt,
                prm,
                jstragectories,
                ostrajectories,
                pid,
                lqr,
                foc,
                kmfilter,
                mpc,
                bldc,
                servo,
                stepper,
                linearActuator,
              });
              setEmail("");
            } catch (e) {}
          }}
        >
          Submit
        </Button>
      </Box>
      <br />
      <Box
        sx={{ width: 1000, margin: 1, marginLeft: "auto", marginRight: "auto" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
            <FormLabel component="legend">Inverse Kinematics</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={jacobian3dik}
                    onChange={(event) => setJacobian3dik(event.target.checked)}
                    name="3djacobianik"
                  />
                }
                label="3D Jacobian Inverse Kinematic"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={ccd}
                    onChange={(event) => setCcd(event.target.checked)}
                    name="ccd"
                  />
                }
                label="Cyclic Coordinate Descent"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={lmdls}
                    onChange={(event) => setLmdls(event.target.checked)}
                    name="lmdls"
                  />
                }
                label="Levenberg-Marquardt Damped Least Squares"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={qncg}
                    onChange={(event) => setQncg(event.target.checked)}
                    name="qncg"
                  />
                }
                label="Quasi-Newton and Conjugate Gradient"
              />
            </FormGroup>
            <br />
            <FormLabel component="legend">Motion Planning</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={astar}
                    onChange={(event) => setAstar(event.target.checked)}
                    name="a*"
                  />
                }
                label="A* Algorithm"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dijkstra}
                    onChange={(event) => setDijkstra(event.target.checked)}
                    name="dijkstra"
                  />
                }
                label="Dijkstra's Algorithm"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rrt}
                    onChange={(event) => setRrt(event.target.checked)}
                    name="rrt"
                  />
                }
                label="Rapidly-exploring Random Tree (RRT)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={prm}
                    onChange={(event) => setPrm(event.target.checked)}
                    name="prm"
                  />
                }
                label="Probabilistic Roadmap (PRM)"
              />
            </FormGroup>
            <br />
            <FormLabel component="legend">Control Theory</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={lqr}
                    onChange={(event) => setLqr(event.target.checked)}
                    name="lqr"
                  />
                }
                label="linear–quadratic regulator (LQR)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={foc}
                    onChange={(event) => setFoc(event.target.checked)}
                    name="foc"
                  />
                }
                label="Field-Oriented Control (FOC)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={kmfilter}
                    onChange={(event) => setKmfilter(event.target.checked)}
                    name="kalmanfilter"
                  />
                }
                label="Kalman filter"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mpc}
                    onChange={(event) => setMpc(event.target.checked)}
                    name="mpc"
                  />
                }
                label="Model predictive control (MPC)"
              />
            </FormGroup>
          </FormControl>
          <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
            <FormLabel component="legend">Dynamics</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={lagrange}
                    onChange={(event) => setLagrange(event.target.checked)}
                    name="lagrange"
                  />
                }
                label="Euler-Lagrange"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newtoneuler}
                    onChange={(event) => setNewtoneuler(event.target.checked)}
                    name="newtoneuler"
                  />
                }
                label="Newton-Euler"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={inversedynamics}
                    onChange={(event) =>
                      setInversedynamics(event.target.checked)
                    }
                    name="inversedynamics"
                  />
                }
                label="Inverse Dynamics"
              />
            </FormGroup>
            <br />
            <br />
            <br />
            <FormLabel component="legend">Trajectory Planning</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={jstragectories}
                    onChange={(event) =>
                      setJstragectories(event.target.checked)
                    }
                    name="jstrajectories"
                  />
                }
                label="Joint Space Trajectories"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={ostrajectories}
                    onChange={(event) =>
                      setOstrajectories(event.target.checked)
                    }
                    name="ostrajectories"
                  />
                }
                label="Operational Space Trajectories"
              />
            </FormGroup>
            <br />
            <br />
            <br />
            <br />
            <br />
            <FormLabel component="legend">Actuators</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bldc}
                    onChange={(event) => setBldc(event.target.checked)}
                    name="bldc"
                  />
                }
                label="Brushless DC Motors"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={servo}
                    onChange={(event) => setServo(event.target.checked)}
                    name="servo"
                  />
                }
                label="Servo Motors"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stepper}
                    onChange={(event) => setStepper(event.target.checked)}
                    name="stepper"
                  />
                }
                label="Stepper Motors"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={linearActuator}
                    onChange={(event) =>
                      setLinearActuator(event.target.checked)
                    }
                    name="linearActuator"
                  />
                }
                label="Linear Actuators"
              />
            </FormGroup>
          </FormControl>
        </Box>
      </Box>
    </>
  );
}

export default More;
